import { TFormValues } from 'legacy/templates/modules/sign-up/types/TFormValues';

export const employeeOptions = [
	{ value: 1, label: 'Just Me' },
	{ value: 2, label: '2 designers' },
	{ value: 10, label: '3-10' },
	{ value: 11, label: '10+' },
];

export const requiredFields: Array<keyof TFormValues> = [
	'firstName',
	'lastName',
	'companyName',
	'email',
	'username',
	'password',
	'employees',
	'companyRole',
	'projectType',
];
